import { styled } from '../../../theme/stitches.config';

export const StyledContainer = styled('section', {
  margin: '0 auto',
  maxWidth: 750,
  padding: '80px 0',
  '@mdMax': {
    padding: '40px 24px',
  },
});

export const StyledPosition = styled('div', {
  padding: '16px 0',
  '+ div': {
    borderTop: '1px solid #C7CAC8',
  },
});
